import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { WorkSection } from "@/components/site/WorkSection";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { usePageMeta } from "@/hooks/useProjects";

export default function Home() {
  const { hash } = useLocation();
  usePageMeta(
    "OURUMDIGITAL | Websites, AI Automation, Social Media & SEO",
    "OURUMDIGITAL builds responsive websites and landing pages, WhatsApp AI automation, social media management and local SEO that help businesses grow."
  );

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 300);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <WorkSection />
        <About />
        <Services />
        <Process />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
